import styled from 'styled-components';

const ButtonStyle = styled.div.attrs((props) => ({}))`
	--lineHeight: 1;
	--lineHeightS: 1;
	--color: ${(props) => (props.color ? props.theme.colors[props.color] : 'var(--primaryColor2)')};
	--background: ${(props) => (props.background ? props.theme.colors[props.background] : 'transparent')};
	--borderColor: ${(props) => (props.borderColor ? props.theme.colors[props.borderColor] : 'transparent')};
	--hoverColor: ${(props) => (props.hoverColor ? props.theme.colors[props.hoverColor] : 'var(--primaryColor1)')};
	--hoverBackground: ${(props) => (props.hoverBackground ? props.theme.colors[props.hoverBackground] : 'transparent')};
	--hoverBorderColor: ${(props) => (props.hoverBorderColor ? props.theme.colors[props.hoverBorderColor] : 'transparent')};
	--paddingV: var(--sp2x);
	--paddingH: var(--sp4x);

	display: inline-block;

	&.ColorYellowTan {
		.button-text {
			color: var(--primaryColor1);
		}

		.btn-icon {
			i {
				color: var(--primaryColor1);
			}
		}
	}

	button,
	a {
		position: relative;
		display: inline-flex;
		justify-content: center;
		color: var(--color);
		background-color: var(--background);
		border: 1px solid var(--borderColor);
		font-weight: inherit;
		transition: all var(--trTime);
		overflow: hidden;
		-webkit-appearance: none;
		cursor: pointer;

		.btn-content {
			position: relative;
			z-index: 1;
			overflow: hidden;
		}
	}

	[class^='giz-'],
	.btn-content {
		line-height: 1.1;
	}

	@media (hover: hover) {
		&:not(.lottie):not(.oval):not(.icon-aside) {
			button:hover,
			a:hover {
				color: var(--hoverColor);
				background-color: var(--hoverBackground);
				border: 1px solid var(--hoverBorderColor);
			}
		}
	}

	&.default {
		--color: ${(props) => (props.color ? props.theme.colors[props.color] : 'var(--primaryColor2)')};
		--background: ${(props) => (props.background ? props.theme.colors[props.background] : 'transparent')};
		--borderColor: ${(props) => (props.borderColor ? props.theme.colors[props.borderColor] : 'var(--primaryColor2)')};
		--hoverColor: ${(props) => (props.hoverColor ? props.theme.colors[props.hoverColor] : 'var(--primaryColor1)')};
		--hoverBackground: ${(props) => (props.hoverBackground ? props.theme.colors[props.hoverBackground] : 'var(--primaryColor2)')};
		--hoverBorderColor: ${(props) => (props.hoverBorderColor ? props.theme.colors[props.hoverBorderColor] : 'var(--primaryColor1)')};

		button,
		a {
			align-items: center;
			justify-content: center;
			border-radius: calc(1.5 * var(--sp1x));
			padding: var(--paddingV) var(--paddingH);

			[class^='giz-'] {
				margin-left: var(--sp1x);
			}

			&:after {
				content: '';
				position: absolute;
				inset: 0;
				border-radius: var(--sp1x);
				background-color: var(--hoverBackground);
				transform: translateY(150%);
				transition: var(--trTime);
			}

			/* @media (hover: hover) {
				&:hover {
					.btn-content {
						color: var(--hoverColor);
					}

					&:after {
						transform: translateY(0);
					}
				}
			} */
		}
	}

	&.lottie {
		--color: ${(props) => (props.color ? props.theme.colors[props.color] : 'var(--primaryColor1)')};
		--hoverColor: ${(props) => (props.hoverColor ? props.theme.colors[props.hoverColor] : 'var(--primaryColor2)')};

		.lottie-wrap {
			margin: 0 0 0 calc(var(--sp1x) * -1);

			svg {
				width: auto !important;
			}
		}

		button,
		a {
			padding: 0;
			align-items: center;
			justify-content: center;

			[class^='giz-'] {
				margin-left: var(--sp1x);
				font-size: var(--h4);
				color: var(--hoverColor);
			}
		}
	}

	&.icon-aside {
		--color: ${(props) => (props.color ? props.theme.colors[props.color] : 'var(--primaryColor1)')};
		--background: ${(props) => (props.background ? props.theme.colors[props.background] : 'var(--primaryColor2)')};
		--borderColor: ${(props) => (props.borderColor ? props.theme.colors[props.borderColor] : 'var(--primaryColor1)')};
		--hoverColor: ${(props) => (props.hoverColor ? props.theme.colors[props.hoverColor] : 'var(--primaryColor2)')};
		--hoverBackground: ${(props) => (props.hoverBackground ? props.theme.colors[props.hoverBackground] : 'var(--primaryColor1)')};
		--hoverBorderColor: ${(props) => (props.hoverBorderColor ? props.theme.colors[props.hoverBorderColor] : 'var(--primaryColor2)')};

		button,
		a {
			align-items: center;
			justify-content: center;
			align-items: stretch;
			color: unset;
			background-color: unset;
			border: unset;

			.btn-icon {
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0 var(--sp2x);
				color: var(--color);
				background-color: var(--background);
				transition: var(--trTime);
				border-radius: var(--sp1x);
			}

			.btn-content:not(.btn-icon) {
				--paddingV: var(--sp2x);

				padding: var(--paddingV) var(--paddingH);
				color: var(--color);
				background-color: var(--background);
				transition: var(--trTime);
				border-radius: var(--sp1x);
			}

			.btn-content {
				.button-text,
				[class^='giz-'] {
					position: relative;
					z-index: 1;
				}

				&:after {
					content: '';
					position: absolute;
					inset: -2px;
					border-radius: var(--sp1x);
					background-color: var(--hoverBackground);
					transform: translateY(100%);
					transition: var(--trTime);
				}
			}

			@media (hover: hover) {
				&:hover {
					color: unset;
					background-color: unset;
					border: unset;

					.btn-content {
						color: var(--hoverColor);

						&:after {
							transform: translateY(0);
						}
					}
				}
			}
		}
	}

	&.oval {
		--color: ${(props) => (props.color ? props.theme.colors[props.color] : 'var(--primaryColor2)')};
		--background: ${(props) => (props.background ? props.theme.colors[props.background] : 'transparent')};
		--borderColor: ${(props) => (props.borderColor ? props.theme.colors[props.borderColor] : 'var(--primaryColor2)')};
		--hoverColor: ${(props) => (props.hoverColor ? props.theme.colors[props.hoverColor] : 'var(--primaryColor1)')};
		--hoverBackground: ${(props) => (props.hoverBackground ? props.theme.colors[props.hoverBackground] : 'var(--primaryColor2)')};
		--hoverBorderColor: ${(props) => (props.hoverBorderColor ? props.theme.colors[props.hoverBorderColor] : 'var(--primaryColor1)')};
		--paddingV: var(--sp1x);
		--paddingH: var(--sp2x);

		button,
		a {
			border-radius: calc(2.5 * var(--sp1x));
			padding: var(--paddingV) var(--paddingH);

			.btn-content {
				position: relative;
				z-index: 1;
			}

			&:after {
				content: '';
				position: absolute;
				inset: 0;
				border-radius: var(--sp1x);
				background-color: var(--hoverBackground);
				transform: translateY(100%);
				transition: var(--trTime);
			}

			@media (hover: hover) {
				&:hover {
					border: 1px solid var(--hoverBorderColor);

					.btn-content {
						color: var(--hoverColor);
					}

					&:after {
						transform: translateY(0);
					}
				}
			}
		}
	}

	&.back {
		--color: ${(props) => (props.color ? props.theme.colors[props.color] : 'var(--primaryColor1)')};
		--hoverColor: ${(props) => (props.hoverColor ? props.theme.colors[props.hoverColor] : 'var(--primaryColor2)')};

		button,
		a {
			padding: 0;

			[class^='giz-'] {
				transform: rotate(180deg);
				margin-right: var(--sp1x);
			}
		}
	}

	&.disabled {
		opacity: 0.5;
		pointer-events: none;

		/* //! For Loading */
		&.icon-aside {
			button,
			a {
				.btn-content:not(.btn-icon) {
					color: white !important;
				}

				.btn-content {
					background-color: gray !important;
					transition: none !important;

					&:after {
						background-color: gray !important;
						transition: none !important;
					}
				}
			}
		}

		&-checked {
			opacity: 0.5;
			pointer-events: none;

			/* //! For Loading */
			&.icon-aside {
				button,
				a {
					.btn-content {
						color: white !important;
						background-color: gray !important;
						transition: none !important;

						&:after {
							background-color: gray !important;
							transition: none !important;
						}
					}
				}
			}
		}

		/* //! For Loading */
		&.for-footer {
			button,
			a {
				background-color: gray !important;
				border: 1px solid gray !important;
			}
		}
	}

	/* //! Loader Styles */
	.btn-icon {
		position: relative;
	}

	.loader {
		position: absolute;
	}

	.hide {
		opacity: 0;
	}

	&.for-footer {
		.btn-content {
			position: relative;
		}

		.loader {
			width: 16px;
			top: 0;
			left: calc(50% - 8px);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--paddingV: var(--sp2x);
		--paddingH: var(--sp4x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--paddingV: var(--sp2x);
		--paddingH: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--paddingV: var(--sp2x);
		--paddingH: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--paddingV: var(--sp2x);
		--paddingH: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--paddingV: var(--sp2x);
		--paddingH: var(--sp3x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--paddingV: var(--sp2x);
		--paddingH: var(--sp3x);

		&.lottie {
			.lottie-wrap {
				height: var(--sp3x);
			}
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--paddingV: var(--sp2x);
		--paddingH: var(--sp3x);

		&.lottie {
			.lottie-wrap {
				height: var(--sp4x);
			}
		}
	}
`;
export default ButtonStyle;
